(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FollowupTypeDetailController', FollowupTypeDetailController);

    FollowupTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FollowupType'];

    function FollowupTypeDetailController($scope, $rootScope, $stateParams, entity, FollowupType) {
        var vm = this;
        vm.followupType = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:followupTypeUpdate', function(event, result) {
            vm.followupType = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
